import { c as _c } from "react/compiler-runtime";
import { InfoIcon } from '@systemeio/ui/icons';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CleanIcon, ExplicitConsentsIcon, VerificationIcon, WarmUpIcon } from '../icons';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { getSuccessfullyContactImportLink } from '../utils/get-successfully-contact-import-link';
import useUser from 'shared/hooks/use-user';
export const ContactImportWarning = () => {
  const $ = _c(55);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ExplicitConsentsIcon className="shrink-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.contact_import.warning_message.explicit_consents.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.contact_import.warning_message.explicit_consents.description");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      icon: t0,
      title: t1,
      description: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CleanIcon className="shrink-0" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("dashboard.contact_import.warning_message.clean.title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.contact_import.warning_message.clean.description");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = {
      icon: t4,
      title: t5,
      description: t6
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <VerificationIcon className="shrink-0" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("dashboard.contact_import.warning_message.verification.title");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dashboard.contact_import.warning_message.verification.description");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = {
      icon: t8,
      title: t9,
      description: t10
    };
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <WarmUpIcon className="shrink-0" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("dashboard.contact_import.warning_message.warm_up.title");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("dashboard.contact_import.warning_message.warm_up.description");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = {
      icon: t12,
      title: t13,
      description: t14
    };
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15 || $[34] !== t3 || $[35] !== t7) {
    t16 = [t3, t7, t11, t15];
    $[32] = t11;
    $[33] = t15;
    $[34] = t3;
    $[35] = t7;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const warnings = t16;
  const t17 = user?.dashboardLocale;
  let t18;
  if ($[37] !== t17) {
    t18 = getSuccessfullyContactImportLink(t17);
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const contactImportLink = t18;
  let t19;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <InfoIcon className="fill-brand-primary" />;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t("dashboard.contact_import.warning_message.title");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t20) {
    t21 = <div className="flex items-baseline gap-1">{t19}<span className="text-text-primary text-lg font-bold">{t20}</span></div>;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== warnings) {
    t22 = <div className="text-text-primary flex flex-col gap-2">{warnings.map(_temp)}</div>;
    $[44] = warnings;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t) {
    t23 = t("dashboard.contact_import.warning_message.article_link");
    $[46] = t;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== contactImportLink || $[49] !== t23) {
    t24 = <LinkWithoutPrefetch target="_blank" rel="noopener noreferrer" className="primary-link font-bold" href={contactImportLink}>{t23}</LinkWithoutPrefetch>;
    $[48] = contactImportLink;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t21 || $[52] !== t22 || $[53] !== t24) {
    t25 = <div className={"border-danger bg-background-secondary flex flex-col gap-7 rounded-md\n        border-l-[5px] p-6"}>{t21}{t22}{t24}</div>;
    $[51] = t21;
    $[52] = t22;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  return t25;
};
function _temp(t0, index) {
  const {
    icon,
    title,
    description
  } = t0;
  return <div className="flex items-center gap-2" key={index}>{icon}<div className="flex flex-col gap-1"><span className="font-bold">{title}</span><span>{description}</span></div></div>;
}